import { MealTag } from '@tovala/browser-apis-combinedapi'
import { orderBy } from 'lodash-es'
import { TAG_IDS } from 'utils/meals'

export function getDisplayTags({ tags }: { tags: MealTag[] }) {
  const displayTags = orderBy(tags, 'priority')
    .filter((tag) => {
      return (
        tag.id === TAG_IDS.PREMIUM ||
        tag.displayMode === 'banner_text' ||
        tag.displayMode === 'menu_category' ||
        tag.displayMode === 'menu_subtitle'
      )
    })
    .map(({ collapsedTitle, displayMode, title }) => {
      if (
        (displayMode === 'menu_category' || displayMode === 'menu_subtitle') &&
        collapsedTitle
      ) {
        return { titleCollapsed: collapsedTitle, titleExpanded: title }
      }

      return title
    })

  return displayTags
}
